import { MutationTree } from 'vuex'
import { SET_ANALYTICS } from './mutation-types'
import { DealerSiteAnalyticsState } from './state'

export default {
  [SET_ANALYTICS](state, analytics: DealerSiteAnalyticsState) {
    Object.assign(state, analytics)
  }
} as MutationTree<DealerSiteAnalyticsState>
